import {SortDirection} from "@tailflow/laravel-orion/lib/drivers/default/enums/sortDirection";
import {RegionalPractice} from "../../../models/RegionalPractice";

export default {
  namespaced: true,
  state: {
    fetchedListing: [],
    listingTotalItems: 0,
    isLoading: false,
    fetchedDetail: {},
  },
  getters: {
    getFetchedListing: (state) => state.fetchedListing,
    getListingTotalItems: (state) => state.listingTotalItems,
    getIsLoading: (state) => state.isLoading,
    getFetchedDetail: (state) => state.fetchedDetail,
  },
  mutations: {
    setFetchedListing(state, val) {
      state.fetchedListing = val;
    },
    setListingTotalItems(state, val) {
      state.listingTotalItems = val;
    },
    setIsLoading(state, val) {
      state.isLoading = val;
    },
    setFetchedDetail(state, val) {
      state.fetchedDetail = val;
    }
  },
  actions: {
    async fetchListing({ commit, dispatch }, { options, search, only_trashed }) {
      commit('setIsLoading', true);

      const { sortBy, sortDesc, page, itemsPerPage } = options;

      let queryBuilder = RegionalPractice
        .$query()
        .lookFor(search);

      if (only_trashed) {
        queryBuilder.onlyTrashed();
      }

      if (sortBy[0]) {
        queryBuilder.sortBy(sortBy[0], sortDesc[0] ? SortDirection.Desc : SortDirection.Asc)
      }

      queryBuilder.search(itemsPerPage, page).then((response) => {
        if (response.length > 0) {
          commit('setListingTotalItems', response[0].$response.data.meta.total);
        } else {
          commit('setListingTotalItems', 0);
        }
        commit('setFetchedListing', response.map((item) => item.$attributes));
      }).catch(() => {
        dispatch("snackbar/showUnknownError", null, { root: true })
      }).finally(() => {
        commit("setIsLoading", false);
      })
    },
    async destroyItem({ commit, dispatch }, { id, isForce } ) {
      commit('setIsLoading', true);

      await RegionalPractice.$query().destroy(id, isForce).then(() => {
        dispatch('snackbar/showSuccessfullyDelete', null, { root: true });
      }).catch(() => {
        dispatch('snackbar/showDeleteError', null, { root: true })
      }).finally(() => {
        commit('setIsLoading', false);
      });
    },
    async restoreItem({ commit, dispatch }, id ) {
      commit('setIsLoading', true);

      await RegionalPractice.$query().restore(id).then(() => {
        dispatch('snackbar/showSuccessfullyRestore', null, { root: true })
      }).catch(() => {
        dispatch('snackbar/showErrorRestore', null, { root: true })
      }).finally(() => {
        commit('setIsLoading', false)
      });
    },
    async storeItem({ commit, dispatch }, { form, isNeedRedirect, router }) {
      commit('setIsLoading', true)
      let catalog = null;

      RegionalPractice.$query().store(form).then((response) => {
        catalog = response.$attributes.id;
        dispatch('snackbar/showSuccessfullySaved', null, { root: true });
      }).catch(() => {
        dispatch('snackbar/showSaveError', null, { root: true });
      }).finally(() => {
        commit('setIsLoading', false)
        if (catalog) {
          if (isNeedRedirect) {
            router.push({ name: 'regional-practices-index' });
          } else {
            router.push({ name: 'regional-practices-edit', params: { id: catalog } });
          }
        }
      })
    },
    async fetchDetail({ commit, dispatch }, id) {
      commit('setIsLoading', true);

      RegionalPractice.$query().find(id).then((response) => {
        commit('setFetchedDetail', response.$attributes);
      }).catch(() => {
        dispatch('snackbar/showUnknownError', null, { root: true });
      }).finally(() => {
        commit('setIsLoading', false);
      })
    },
    async updateItem({ commit, dispatch }, { form, isNeedRedirect, router }) {
      commit('setIsLoading', true);
      let hasErrors = false;

      RegionalPractice.$query().update(form.id, form).then((response) => {
        commit('setFetchedDetail', response.$attributes);
        dispatch("snackbar/showSuccessfullySaved", null, { root: true })
      }).catch(() => {
        hasErrors = true;
        dispatch("snackbar/showUnknownError", null, { root: true });
      }).finally(() => {
        commit('setIsLoading', false);

        if (!hasErrors) {
          if (isNeedRedirect) {
            router.push({ name: 'regional-practices-index' });
          }
        }
      })
    }
  }
}
